import {ReadCommitResult} from "isomorphic-git"

/** Sort commits by descending commit timestamps */
export const sortCommit = (a: ReadCommitResult, b: ReadCommitResult) => b.commit.committer.timestamp - a.commit.committer.timestamp
export const groupCommitsByDates = (commits: ReadCommitResult[]): Record<string, ReadCommitResult[]> => {
  const dates = commits.map((c) => c.commit.committer.timestamp).map((t) => new Date(t * 1000).toDateString())
  const uniqueDates = [... new Set(dates)].sort()

  const commitEntries = uniqueDates.map((date) => [date, commits.filter(c => new Date(c.commit.committer.timestamp * 1000).toDateString() === date)])
  return Object.fromEntries(commitEntries)
}
export const findCommitNumber = (commits: ReadCommitResult[], oid: string): number => {
  const index = commits.findIndex(c => oid === c.oid)
  if (index === -1) { throw Error(`OID ${oid} is not found in commit records!`) }
  return commits.length - index // commits were sorted by descending commit timestamps; Revert the order
}
export const isToday = (dateString: string): boolean => dateString === new Date().toDateString()